import React from "react";
import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import PageHero from "../components/PageHero";
import { company } from "../mock";
import useSEO from "../hooks/useSEO";

const links = [
  { to: "/services/roofing", label: "Roofing" },
  { to: "/services/roof-repair", label: "Roof Repair" },
  { to: "/services/storm-damage-repairs", label: "Storm Damage Repair" },
  { to: "/services/siding", label: "Siding" },
  { to: "/services/gutters", label: "Gutters" },
  { to: "/service-areas", label: "Service Areas" },
  { to: "/blog", label: "Blog" },
  { to: "/contact", label: "Contact" },
];

const NotFound = () => {
  useSEO({
    title: "Page Not Found | Fab Build Pro",
    description: "The page you're looking for doesn't exist. Explore Fab Build Pro roofing, siding and gutter services in Northern Virginia or call 703-766-6599.",
    status: 404,
  });

  return (
    <>
      <PageHero title="Page Not Found" subtitle="Sorry, we couldn't find that page. It may have moved — try one of these instead." />
      <section className="bg-brand-cream py-16" data-testid="not-found-page">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <div className="flex flex-wrap justify-center gap-3">
            {links.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`not-found-link-${l.to.replace(/\//g, "-").slice(1)}`}
                className="inline-flex items-center gap-1.5 bg-white border border-black/10 text-brand-navy rounded-full px-4 py-2 text-sm font-medium hover:bg-brand-orange hover:text-white hover:border-brand-orange transition-colors"
              >
                {l.label}
              </Link>
            ))}
          </div>
          <div className="flex flex-wrap justify-center gap-3 mt-10">
            <a href={company.phoneHref} data-testid="not-found-call-btn" className="inline-flex items-center gap-2 bg-brand-orange hover:bg-brand-orangedark text-white font-semibold px-6 py-3.5 rounded-full shadow-lg transition-colors">
              <Phone className="w-5 h-5" /> Call {company.phone}
            </a>
            <Link to="/" data-testid="not-found-home-btn" className="inline-flex items-center gap-2 bg-brand-navy text-white font-semibold px-6 py-3.5 rounded-full transition-colors hover:bg-brand-slate">
              Back to Home <ArrowRight className="w-5 h-5" />
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default NotFound;
